
import React from 'react'
import "./BybPrivacyPolicy.css"
import { Navbar } from 'react-bootstrap'
import HeaderNavbar from '../BybNavbar/HeaderNavbar'
import BybFooter from '../BybFooter/BybFooter'
function BybPrivacyPolicy() {
  return (
    <>
    <HeaderNavbar/>
     <section className='byb-privacypolicy'>
        <div className='container'>
            <div className='byb-privacypolicy-header'>
            <h4>Privacy Policy</h4>
            </div>
           
<div className='privacypolicy-firstsection'>
<h6>Scope</h6>
<p>This Privacy Policy outlines how Brew Your Brand (BYB) collects, uses, and safeguards personal information gathered through our website during the purchase of the Brand Audit Kit.</p>

<h6>Information Collection</h6>
<p>We collect the following personal information at the time of purchase: Name, Email address, Billing and shipping addresses, Phone number, GST number (if applicable), Company/Business name</p>

<h6>Use of Information</h6>
<ul>
    <li>The information we collect is used to:</li>
    <li>Orders and deliver products.</li>
    <li>Provide customer support and respond to inquiries.</li>
    <li>Enhance user experience through website personalization.</li>
    <li>Track usage patterns to improve promotional strategies.</li>
    <li>Analyse user interaction to refine and optimize our offerings.</li>
    <li>Send marketing communications, from which you may opt out anytime.</li>
</ul>

</div>


<div className='privacypolicy-secondsection'>
    <h6>Sensitive Information</h6>
    <p>In cases where users voluntarily provide sensitive data, such as GST or business registration details, BYB will only use such information as necessary for the transaction and to fulfil legal obligations.</p>

<h6>Third-Party Integrations and Payment Processing</h6>
<p>Payments are securely processed through third-party payment gateways that may require additional personal information. BYB does not store payment details. If our website includes social media buttons or third-party links, please note that clicking on them is at your discretion, and BYB is not responsible for third-party content or privacy practices.</p>

<h6>Cookies and Tracking</h6>
<p>Our website uses cookies to enhance user experience and gather insights on user behaviour, including browsing patterns and preferences. Adjustments to cookie settings can be made through your browser.</p>

<h6>Age Requirement</h6>
<p>By using the Brew Your Brand website, you confirm that you are at least 18 years old. If you are under 18, you may only use the website with the consent of a parent or guardian.</p>

<h6>Data Rights</h6>
<p>Customers have the right to request deletion of their personal data by contacting us via our official email. Upon receiving your request, we will ensure your data is erased from our records within a reasonable timeframe, unless otherwise required by law.</p>

<h6>Liability for Third-Party Links</h6>
<p>The Brew Your Brand website may contain links to third-party websites. Please note that we are not responsible for the privacy practices or content of these external sites. Clicking on these links is at your own discretion, and Brew Your Brand disclaims liability for any consequences arising from your interactions with third-party websites.</p>

<h6>Security</h6>
<p>We are committed to protecting your personal information. Appropriate measures are in place to prevent unauthorized access, disclosure, or misuse of your data.</p>

<h6>Complaint Handling</h6>
<p>In case of complaints related to misuse of the website, BYB will use collected data to investigate and resolve any reported issues.</p>

<h6>Updates to Privacy Policy</h6>
<p>Brew Your Brand reserves the right to update this Privacy Policy. Please check this page periodically to stay informed of changes.</p>

<h6>Contact Information</h6>
<p>For privacy-related inquiries, please contact us at <a href="mailto:support@brewyourbrand.in"> support@brewyourbrand.in</a></p>
</div>




        </div>
        
        
         </section> 


    <BybFooter/>

    </>

   
  )
}

export default BybPrivacyPolicy
